var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"l-title"},[_c('div',{staticClass:"col-row col-noGutter"},[_c('div',{staticClass:"col-3"},[_c('span',[_vm._v(_vm._s(_vm.syncedTitle))])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.syncedIsShowBT),expression:"syncedIsShowBT"}],staticClass:"col-4"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }